import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "descriptions"
}
const _hoisted_2 = { class: "description-checked fs-7 fst-italic ms-4 mb-1" }
const _hoisted_3 = { class: "description-unchecked fs-7 fst-italic ms-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.itemName)
  }, [
    _createVNode(_component_input_checkbox_boolean, {
      modelValue: _ctx.item,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item) = $event)),
      label: _ctx.$t(_ctx.itemDescriptionKey),
      name: _ctx.itemName,
      errors: _ctx.errors,
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "label", "name", "errors", "disabled"]),
    (_ctx.itemId.includes('medicine'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('descriptionProductChoice' + _ctx.toInitCapitalize(_ctx.itemDescriptionKey) + 'Checked')), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('descriptionProductChoice' + _ctx.toInitCapitalize(_ctx.itemDescriptionKey) + 'Unchecked')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}